/* global $ */

const RGBA = require('./RGBA')
const env = require('./env')

module.exports = data => {
    const shadow = RGBA.fromHex(data.hex)
    const isNewApp = env.dev || data.activeAppVersion === 2
    const {assets} = data

    let landerUrl

    shadow.a = 0.5

    if (isNewApp) {
        landerUrl = assets.hero_output ? assets.hero_output.url : data.lander_image_new
    } else {
        landerUrl = data.lander_image
    }

    /* eslint-disable max-len */
    $(
        `<style type='text/css'>              
            a.link-highlight {box-shadow: inset 0 -10px 0 ${shadow};}            
            a.link-highlight:hover {box-shadow: inset 0 -33px 0 ${shadow};}
            
            .success-trouble a.link-highlight {box-shadow: inset 0 -7px 0 ${shadow};}
            .success-trouble a.link-highlight:hover {box-shadow: inset 0 -25px 0 ${shadow};}
            
            @media (max-width: 1450px) {
                .success-trouble a.link-highlight {box-shadow: inset 0 -6px 0 ${shadow};}
                .success-trouble a.link-highlight:hover {box-shadow: inset 0 -23px 0 ${shadow};}
            }
    
            .form-control:active, .form-control:focus {
                border: 1px solid #${data.hex};
                box-shadow: 0px 0px 2px 0px ${shadow};
            }
            
            .content:after {
                background-image: url(${landerUrl})
            }
            
            .slider .slider-header .active button {
                color: #${data.branding.primary};
            }
        </style>`
        /* eslint-enable */
    ).appendTo("head")
}



/** WEBPACK FOOTER **
 ** ./js/credentials/applyOrganisationBranding.js
 **/